import { Avatar, Separator, Text } from "../../../components";
import { CaretDownIcon, CaretUpIcon } from "../../../components/icons";
import React from "react";
import { E_Route } from "@repo-sapiens/constants";
import {
  AttendeeCaretIconStyle,
  AttendeeHeaderStyle,
  AttendeeInfoBodyStyle,
  AttendeeLeftStyle,
  AttendeeStyle,
} from "../styles";

type Props = {
  defaultExpanded?: boolean;
  title: string;
  subtitle?: string;
  transcript: string;
  id: string;
};
export const TranscriptCard: React.FC<Props> = ({
  defaultExpanded,
  title,
  subtitle,
  transcript,
  id,
}) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded);
  const onExpand = () => {
    setExpanded(!expanded);
  };
  return (
    <div className={AttendeeStyle(expanded || false)}>
      <div className={AttendeeHeaderStyle} onClick={onExpand}>
        <div className={AttendeeLeftStyle}>
          <Avatar username="Hello" size="2" />
          <Separator.Vertical spacing={1} />
          <div>
            <Text.BodySM color="primary">{title}</Text.BodySM>
            <Text.Body2XS color="seconday">{subtitle}</Text.Body2XS>
          </div>
        </div>
        {expanded ? (
          <CaretUpIcon fill="highlight/1" style={AttendeeCaretIconStyle} />
        ) : (
          <CaretDownIcon fill="highlight/1" style={AttendeeCaretIconStyle} />
        )}
      </div>
      <div className={AttendeeInfoBodyStyle}>
        <div>
          <Text.Link size="body-sm" href={`${E_Route.MeetingTranscript}/${id}`}>
            See in full view
          </Text.Link>
        </div>
        <div dangerouslySetInnerHTML={{ __html: transcript }} />
      </div>
    </div>
  );
};
